import _extends from '@babel/runtime/helpers/extends';

var SMALL_SIZE_CLASSES = {
  checked: 'translate-x-14 rtl:-translate-x-14',
  root: 'p-0 w-32 h-18 rounded overflow-visible',
  switchBase: 'p-2',
  thumb: 'w-14 h-14 bg-bg-primary shadow-02',
  track: 'bg-interactive-secondary-hover rounded'
};
var MEDIUM_SIZE_CLASSES = _extends({}, SMALL_SIZE_CLASSES, {
  checked: 'translate-x-16 rtl:-translate-x-16',
  root: 'p-0 w-36 h-20 rounded overflow-visible',
  thumb: 'w-16 h-16 bg-bg-primary shadow-02'
});
var LARGE_SIZE_CLASSES = _extends({}, SMALL_SIZE_CLASSES, {
  checked: 'translate-x-20 rtl:-translate-x-20',
  root: 'p-0 w-44 h-24 rounded overflow-visible',
  thumb: 'w-20 h-20 bg-bg-primary shadow-02'
});
var SIZE_CLASSES = {
  large: LARGE_SIZE_CLASSES,
  medium: MEDIUM_SIZE_CLASSES,
  small: SMALL_SIZE_CLASSES
};

export { SIZE_CLASSES };
//# sourceMappingURL=utils.js.map
